import { p } from './core.js'

// Categoria 1 — Mesas + Aparadores (R3)
// Modelos: MES-HO-A..H, MES-L-A..B, MES-D-A, MES-R-A..B, MES-J-A..B, MES-CAB-A..F, APA-A..B
//
// Constantes padrão R3 (em metros):
//   h_test_mesa     = 0.40   (testeira frontal de mesa)
//   h_test_aparador = 0.20   (testeira frontal de aparador, mais baixa)
//   h_gav_mesa      = 0.10   (gaveta fina de mesa)
//   h_gav_cab       = 0.12   (gaveta de cabeceira)
//   h_gav_comoda    = 0.20   (gaveta de cômoda/gaveteiro)
//   C_gab           = 0.45   (largura do gabinete fechado, R3)
//   C_gav           = 0.45   (largura do gaveteiro lateral, R3)
//   C_nicho         = 0.40   (largura do nicho lateral, R3)
//
// Regra de cor:
//   - Peças expostas (tampo, frentes, laterais externas, testeiras, portas, prateleiras
//     dentro de nicho aberto) → cor escolhida pelo cliente
//   - Peças internas escondidas (interior de gabinete fechado, traseiras/laterais de
//     gaveta, divisórias internas estruturais) → MDF branco
//   - Fundos 6mm → sempre branco (sem opção colorida nesta espessura para interior)

export const MESAS = {

  // ── MES-HO-A — Mesa Home Office Sem Gavetas ─────────────────────────────────
  'Mesa Home Office Sem Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',           '15', v => v.C * v.P, 1),
      p('Lateral pé-painel','15', v => v.P * v.A, 2),
      p('Testeira frontal', '15', v => v.C * 0.40, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-HO-B — Mesa Home Office com 1 Gaveta ────────────────────────────────
  'Mesa Home Office 1 Gaveta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',           '15', v => v.C * v.P, 1),
      p('Lateral pé-painel','15', v => v.P * v.A, 2),
      p('Testeira frontal', '15', v => v.C * 0.40, 1),
      p('Frente gaveta',    '15', v => 0.45 * 0.10, 1),
      p('Traseira gaveta',  '15', v => 0.45 * 0.10, 1, 'branco'),
      p('Lateral gaveta',   '15', v => v.P * 0.10,  2, 'branco'),
      p('Fundo gaveta',     '6',  v => 0.45 * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 2, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── Mesa Home Office 2 Gavetas (variante legado, não está no R3) ────────────
  // 2 gavetas lado a lado de largura C/2 cada, altura 0.10m. Igual MES-HO-B
  // porém dividindo a frente em 2 ao invés de 1 gaveta de 0.45m.
  'Mesa Home Office 2 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',           '15', v => v.C * v.P, 1),
      p('Lateral pé-painel','15', v => v.P * v.A, 2),
      p('Testeira frontal', '15', v => v.C * 0.40, 1),
      p('Frente gaveta',    '15', v => (v.C/2) * 0.10, 2),
      p('Traseira gaveta',  '15', v => (v.C/2) * 0.10, 2, 'branco'),
      p('Lateral gaveta',   '15', v => v.P * 0.10,     4, 'branco'),
      p('Fundo gaveta',     '6',  v => (v.C/2) * v.P,  2),
    ],
    ferragens: { dobradica: 0, corredica: 4, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-HO-C — Mesa Home Office Industrial ──────────────────────────────────
  // MDF integral igual à MES-HO-A. A estrutura metalon (terceirizada) entra como
  // custo fixo via extraFixo, somado ao preço final depois do multiplicador.
  'Mesa Home Office Industrial': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',           '15', v => v.C * v.P, 1),
      p('Lateral pé-painel','15', v => v.P * v.A, 2),
      p('Testeira frontal', '15', v => v.C * 0.40, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
    extraFixo: 500,  // estrutura metalon terceirizada
  },

  // ── MES-HO-D — Mesa Home Office com Gabinete Fechado Lateral ────────────────
  'Mesa Home Office Gabinete': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo geral',                 '15', v => v.C * v.P, 1),
      p('Lateral externa esquerda',    '15', v => v.P * v.A, 1),
      p('Lateral interna gabinete',    '15', v => v.P * v.A, 1, 'branco'),
      p('Lateral externa direita',     '15', v => v.P * v.A, 1),
      p('Tampo do gabinete',           '15', v => 0.45 * v.P, 1, 'branco'),
      p('Base do gabinete',            '15', v => 0.45 * v.P, 1, 'branco'),
      p('Testeira frontal (toda mesa)','15', v => v.C * 0.40, 1),
      p('Porta de giro do gabinete',   '15', v => 0.45 * (v.A - 0.40), 1),
      p('Fundo do gabinete',           '6',  v => 0.45 * v.A, 1),
    ],
    ferragens: { dobradica: 2, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-HO-E — Mesa Home Office com Nicho Duplo Lateral ─────────────────────
  // Nicho aberto: peças do nicho ficam expostas, então cor (não branco).
  'Mesa Home Office Nicho Duplo': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo geral',                  '15', v => v.C * v.P, 1),
      p('Lateral externa esquerda',     '15', v => v.P * v.A, 1),
      p('Lateral interna nicho',        '15', v => v.P * v.A, 1),
      p('Lateral externa direita',      '15', v => v.P * v.A, 1),
      p('Prateleira intermediária nicho','15',v => 0.40 * v.P, 1),
      p('Base do nicho',                '15', v => 0.40 * v.P, 1),
      p('Testeira frontal (só vão)',    '15', v => (v.C - 0.40) * 0.40, 1),
      p('Fundo do nicho',               '6',  v => 0.40 * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-HO-F — Mesa Home Office com Nicho Duplo + Gaveta Superior ───────────
  'Mesa Home Office Nicho e Gaveta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo geral',                  '15', v => v.C * v.P, 1),
      p('Lateral externa esquerda',     '15', v => v.P * v.A, 1),
      p('Lateral interna nicho',        '15', v => v.P * v.A, 1),
      p('Lateral externa direita',      '15', v => v.P * v.A, 1),
      p('Prateleira intermediária nicho','15',v => 0.40 * v.P, 1),
      p('Base do nicho',                '15', v => 0.40 * v.P, 1),
      p('Testeira frontal',             '15', v => (v.C - 0.40) * 0.40, 1),
      p('Testeira atrás da gaveta',     '15', v => (v.C - 0.40) * 0.40, 1, 'branco'),
      p('Fundo do nicho',               '6',  v => 0.40 * v.A, 1),
      p('Frente gaveta superior',       '15', v => (v.C - 0.40) * 0.10, 1),
      p('Traseira gaveta superior',     '15', v => (v.C - 0.40) * 0.10, 1, 'branco'),
      p('Lateral gaveta superior',      '15', v => v.P * 0.10, 2, 'branco'),
      p('Fundo gaveta superior',        '6',  v => (v.C - 0.40) * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 2, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-HO-G — Mesa Bela (gaveteiro lateral 3 gavetas) ──────────────────────
  'Mesa Bela': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo geral',                '15', v => v.C * v.P, 1),
      p('Lateral externa esq (gav.)', '15', v => v.P * v.A, 1),
      p('Lateral interna gaveteiro',  '15', v => v.P * v.A, 1, 'branco'),
      p('Lateral externa direita',    '15', v => v.P * v.A, 1),
      p('Base do gaveteiro',          '15', v => 0.45 * v.P, 1, 'branco'),
      p('Testeira frontal (vão)',     '15', v => (v.C - 0.45) * 0.40, 1),
      p('Fundo do gaveteiro',         '6',  v => 0.45 * v.A, 1),
      p('Frente gaveta',              '15', v => 0.45 * 0.20, 3),
      p('Traseira gaveta',            '15', v => 0.45 * 0.20, 3, 'branco'),
      p('Lateral gaveta',             '15', v => v.P * 0.20,  6, 'branco'),
      p('Fundo gaveta',               '6',  v => 0.45 * v.P, 3),
    ],
    ferragens: { dobradica: 0, corredica: 6, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-HO-H — Mesa Bela Completa (gaveteiro + gaveta superior) ─────────────
  'Mesa Bela Completa': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo geral',                '15', v => v.C * v.P, 1),
      p('Lateral externa esq (gav.)', '15', v => v.P * v.A, 1),
      p('Lateral interna gaveteiro',  '15', v => v.P * v.A, 1, 'branco'),
      p('Lateral externa direita',    '15', v => v.P * v.A, 1),
      p('Base do gaveteiro',          '15', v => 0.45 * v.P, 1, 'branco'),
      p('Testeira frontal (vão)',     '15', v => (v.C - 0.45) * 0.40, 1),
      p('Fundo do gaveteiro',         '6',  v => 0.45 * v.A, 1),
      p('Frente gaveta gaveteiro',    '15', v => 0.45 * 0.20, 3),
      p('Traseira gaveta gaveteiro',  '15', v => 0.45 * 0.20, 3, 'branco'),
      p('Lateral gaveta gaveteiro',   '15', v => v.P * 0.20,  6, 'branco'),
      p('Fundo gaveta gaveteiro',     '6',  v => 0.45 * v.P, 3),
      p('Frente gaveta superior',     '15', v => (v.C - 0.45) * 0.10, 1),
      p('Traseira gaveta superior',   '15', v => (v.C - 0.45) * 0.10, 1, 'branco'),
      p('Lateral gaveta superior',    '15', v => v.P * 0.10, 2, 'branco'),
      p('Fundo gaveta superior',      '6',  v => (v.C - 0.45) * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 8, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-L-A — Mesa em L Básica (TUDO 25mm) ──────────────────────────────────
  'Mesa em L': {
    entradas: ['C1','C2','P','A'],
    pecas: [
      p('Tampo C1',                       '25', v => v.C1 * v.P, 1),
      p('Tampo C2 (com recuo de quina)',  '25', v => v.P * (v.C2 - v.P), 1),
      p('Lateral externa',                '25', v => v.P * v.A, 2),
      p('Lateral central (quina)',        '25', v => v.P * v.A, 1),
      p('Testeira C1',                    '25', v => v.C1 * 0.40, 1),
      p('Testeira C2',                    '25', v => (v.C2 - v.P) * 0.40, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-L-B — Mesa em L com Gaveteiro 3 Gavetas (TUDO 25mm, gavetas 25mm tb) ─
  'Mesa em L com Gaveteiro': {
    entradas: ['C1','C2','P','A'],
    pecas: [
      // Base MES-L-A
      p('Tampo C1',                       '25', v => v.C1 * v.P, 1),
      p('Tampo C2 (com recuo de quina)',  '25', v => v.P * (v.C2 - v.P), 1),
      p('Lateral externa',                '25', v => v.P * v.A, 2),
      p('Lateral central (quina)',        '25', v => v.P * v.A, 1),
      p('Testeira C1',                    '25', v => v.C1 * 0.40, 1),
      p('Testeira C2',                    '25', v => (v.C2 - v.P) * 0.40, 1),
      // Adicional gaveteiro
      p('Divisória do gaveteiro',         '25', v => v.P * v.A, 1, 'branco'),
      p('Base do gaveteiro',              '25', v => 0.45 * v.P, 1, 'branco'),
      p('Fundo do gaveteiro',             '6',  v => 0.45 * v.A, 1),
      p('Frente gaveta',                  '25', v => 0.45 * 0.20, 3),
      p('Traseira gaveta',                '25', v => 0.45 * 0.20, 3, 'branco'),
      p('Lateral gaveta',                 '25', v => v.P * 0.20,  6, 'branco'),
      p('Fundo gaveta',                   '6',  v => 0.45 * v.P, 3),
    ],
    ferragens: { dobradica: 0, corredica: 6, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-D-A — Mesa Dupla com Gabinete Fechado Lateral ───────────────────────
  // (Catálogo R3 chama de "Mesa Diretor"; manual interno mantém "Mesa Dupla".)
  'Mesa Dupla': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo geral',                 '15', v => v.C * v.P, 1),
      p('Lateral externa esquerda',    '15', v => v.P * v.A, 1),
      p('Lateral interna gabinete',    '15', v => v.P * v.A, 1, 'branco'),
      p('Lateral externa direita',     '15', v => v.P * v.A, 1),
      p('Tampo do gabinete',           '15', v => 0.45 * v.P, 1, 'branco'),
      p('Base do gabinete',            '15', v => 0.45 * v.P, 1, 'branco'),
      p('Divisória horiz. gabinete',   '15', v => 0.45 * v.P, 1, 'branco'),
      p('Testeira frontal (vão)',      '15', v => (v.C - 0.45) * 0.40, 1),
      p('Porta de giro',               '15', v => 0.45 * (v.A - 0.10 - 0.04), 1),
      p('Fundo do gabinete',           '6',  v => 0.45 * v.A, 1),
      p('Frente gaveta superior',      '15', v => 0.45 * 0.10, 1),
      p('Traseira gaveta',             '15', v => 0.45 * 0.10, 1, 'branco'),
      p('Lateral gaveta',              '15', v => v.P * 0.10,  2, 'branco'),
      p('Fundo gaveta',                '6',  v => 0.45 * v.P, 1),
    ],
    ferragens: { dobradica: 2, corredica: 2, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-R-A — Mesa de Reunião com Laterais Cheias (TUDO 25mm) ───────────────
  'Mesa de Reunião com Laterais': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',              '25', v => v.C * v.P, 1),
      p('Lateral (até chão)', '25', v => v.P * v.A, 2),
      p('Testeira traseira',  '25', v => v.C * 0.40, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-R-B — Mesa de Reunião com Pé Central tipo "T" (TUDO 25mm) ───────────
  // Constantes do pé tipo T: base 60cm × 40cm.
  'Mesa de Reunião Pé Central': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',                       '25', v => v.C * v.P, 1),
      p('Pé central (painel)',         '25', v => v.P * v.A, 1),
      p('Sapata de apoio (60×40 cm)',  '25', v => 0.60 * 0.40, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-J-A — Mesa de Jantar Base Cúbica Central (40% × 40%) ────────────────
  // Base = caixa de 5 faces (4 verticais + topo, sem face inferior).
  'Mesa de Jantar Base Cúbica': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',                       '25', v => v.C * v.P, 1),
      p('Lateral da base',             '25', v => (0.40*v.P) * (v.A - 0.025), 2),
      p('Testeira da base (fr/fd)',    '25', v => (0.40*v.C) * (v.A - 0.025), 2),
      p('Topo da base',                '25', v => (0.40*v.C) * (0.40*v.P), 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-J-B — Mesa de Jantar Base Cúbica Alongada (60% × 40%) ───────────────
  'Mesa de Jantar Base Alongada': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',                       '25', v => v.C * v.P, 1),
      p('Lateral da base',             '25', v => (0.40*v.P) * (v.A - 0.025), 2),
      p('Testeira da base (fr/fd)',    '25', v => (0.60*v.C) * (v.A - 0.025), 2),
      p('Topo da base',                '25', v => (0.60*v.C) * (0.40*v.P), 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-CAB-A — Cabeceira com Prateleira (nicho aberto) ─────────────────────
  'Cabeceira com Prateleira': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',     '15', v => v.P * v.A, 2),
      p('Tampo',       '15', v => v.C * v.P, 1),
      p('Base',        '15', v => v.C * v.P, 1),
      p('Prateleira',  '15', v => v.C * v.P, 1),
      p('Fundo do móvel','6',v => v.C * v.A, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-CAB-B — Cabeceira com Nicho + 1 Gaveta ──────────────────────────────
  'Cabeceira com Nicho e 1 Gaveta': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                '15', v => v.P * v.A, 2),
      p('Tampo',                  '15', v => v.C * v.P, 1),
      p('Base',                   '15', v => v.C * v.P, 1),
      p('Divisória horizontal',   '15', v => v.C * v.P, 1),
      p('Frente da gaveta',       '15', v => v.C * 0.12, 1),
      p('Traseira da gaveta',     '15', v => v.C * 0.12, 1, 'branco'),
      p('Lateral da gaveta',      '15', v => v.P * 0.12, 2, 'branco'),
      p('Fundo do móvel',         '6',  v => v.C * v.A, 1),
      p('Fundo da gaveta',        '6',  v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 2, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-CAB-C — Cabeceira com 1 Gaveta + Nicho Inferior ─────────────────────
  // Idêntica em peças à MES-CAB-B (só inverte montagem).
  'Cabeceira com 1 Gaveta e Nicho Inferior': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                '15', v => v.P * v.A, 2),
      p('Tampo',                  '15', v => v.C * v.P, 1),
      p('Base',                   '15', v => v.C * v.P, 1),
      p('Divisória horizontal',   '15', v => v.C * v.P, 1),
      p('Frente da gaveta',       '15', v => v.C * 0.12, 1),
      p('Traseira da gaveta',     '15', v => v.C * 0.12, 1, 'branco'),
      p('Lateral da gaveta',      '15', v => v.P * 0.12, 2, 'branco'),
      p('Fundo do móvel',         '6',  v => v.C * v.A, 1),
      p('Fundo da gaveta',        '6',  v => v.C * v.P, 1),
    ],
    ferragens: { dobradica: 0, corredica: 2, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-CAB-D — Cabeceira com Nicho + 2 Gavetas ─────────────────────────────
  'Cabeceira com Nicho e 2 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                '15', v => v.P * v.A, 2),
      p('Tampo',                  '15', v => v.C * v.P, 1),
      p('Base',                   '15', v => v.C * v.P, 1),
      p('Divisória horizontal',   '15', v => v.C * v.P, 1),
      p('Frente da gaveta',       '15', v => v.C * 0.12, 2),
      p('Traseira da gaveta',     '15', v => v.C * 0.12, 2, 'branco'),
      p('Lateral da gaveta',      '15', v => v.P * 0.12, 4, 'branco'),
      p('Fundo do móvel',         '6',  v => v.C * v.A, 1),
      p('Fundo da gaveta',        '6',  v => v.C * v.P, 2),
    ],
    ferragens: { dobradica: 0, corredica: 4, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-CAB-E — Cabeceira com 2 Gavetas (sem nicho) ─────────────────────────
  'Cabeceira com 2 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                '15', v => v.P * v.A, 2),
      p('Tampo',                  '15', v => v.C * v.P, 1),
      p('Base',                   '15', v => v.C * v.P, 1),
      p('Frente da gaveta',       '15', v => v.C * 0.12, 2),
      p('Traseira da gaveta',     '15', v => v.C * 0.12, 2, 'branco'),
      p('Lateral da gaveta',      '15', v => v.P * 0.12, 4, 'branco'),
      p('Fundo do móvel',         '6',  v => v.C * v.A, 1),
      p('Fundo da gaveta',        '6',  v => v.C * v.P, 2),
    ],
    ferragens: { dobradica: 0, corredica: 4, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── MES-CAB-F — Cabeceira com 3 Gavetas ─────────────────────────────────────
  'Cabeceira com 3 Gavetas': {
    entradas: ['C','P','A'],
    pecas: [
      p('Lateral',                '15', v => v.P * v.A, 2),
      p('Tampo',                  '15', v => v.C * v.P, 1),
      p('Base',                   '15', v => v.C * v.P, 1),
      p('Frente da gaveta',       '15', v => v.C * 0.12, 3),
      p('Traseira da gaveta',     '15', v => v.C * 0.12, 3, 'branco'),
      p('Lateral da gaveta',      '15', v => v.P * 0.12, 6, 'branco'),
      p('Fundo do móvel',         '6',  v => v.C * v.A, 1),
      p('Fundo da gaveta',        '6',  v => v.C * v.P, 3),
    ],
    ferragens: { dobradica: 0, corredica: 6, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── APA-A — Aparador Básico (TUDO 25mm, h_test_aparador = 0.20) ─────────────
  'Aparador Básico': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',            '25', v => v.C * v.P, 1),
      p('Lateral',          '25', v => v.P * v.A, 2),
      p('Testeira frontal', '25', v => v.C * 0.20, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },

  // ── APA-B — Aparador com 1 Prateleira Inferior (TUDO 25mm) ──────────────────
  'Aparador com Prateleira': {
    entradas: ['C','P','A'],
    pecas: [
      p('Tampo',                      '25', v => v.C * v.P, 1),
      p('Prateleira intermediária',   '25', v => v.C * v.P, 1),
      p('Lateral',                    '25', v => v.P * v.A, 2),
      p('Testeira frontal',           '25', v => v.C * 0.20, 1),
    ],
    ferragens: { dobradica: 0, corredica: 0, pistao: 0, rodinha: 0, cabide: 0 },
  },
}
